import { Injectable } from '@angular/core';
import { SessionStorage } from '../../core/services/global/storage/session-storage.service';
import { CalculationState } from '../../core/models/calculation-state';
import { CalculationData } from '../../core/models/calculation-data.model';
import { isNullOrUndefined } from 'util';

@Injectable()
export class CalculationStorageService {

  CALCULATION_DATA = 'CALCULATION_DATA';

  private _calculationData: CalculationData;

  constructor(private _sessionStorage: SessionStorage) {
  }

  updateCalculationData(): void {
    this._sessionStorage.put(this.CALCULATION_DATA, this.calculationData);
  }

  updateCalculation(): void {
    if (!isNullOrUndefined(this.calculationData)) {
      this._sessionStorage.put(this.CALCULATION_DATA, this.calculationData);
    }
  }

  isCalculation(): boolean {
    if (!isNullOrUndefined(this.getCalculationData())) {
      return true;
    }
    return false;
  }

  createCalculation(calculationData: CalculationData): void {
    this._calculationData = calculationData;
    this.updateCalculation();
  }

  setCalculationData(calculationData: CalculationData) {
    this.calculationData = calculationData;
  }

  getCalculationData(): CalculationData {
    return this._sessionStorage.get(this.CALCULATION_DATA);
  }

  get calculationData(): CalculationData {
    return this._calculationData;
  }

  set calculationData(value: CalculationData) {
    this._calculationData = value;
  }

}
